import React, {useEffect, useState} from "react";
import DefaultPageHeader from "../../../containers/DefaultPageHeader";
import DefaultTableCard from "../../../containers/DefaultTableCard";
import {Button, Input, Modal, Popconfirm, Space, Spin, Tag, message} from "antd";
import {DeleteOutlined, ExclamationCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import TableLongText from "../../../containers/TableLongText";
import {useNavigate} from "react-router-dom";
import {SystemApi} from "../../../services/SystemApi";
import {ValueUtils} from "../../../utils/ValueUtils";
import moment from "moment";


var password = null


const SystemAuthListPage = () => {
    const navigation = useNavigate()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const requestData = (page = 0) => {
        setLoading(true)
        SystemApi.authList()
            .onSuccess(data => {
                setData(data)
            })
            .onComplete(() => {
                setLoading(false)
            })
    }


    useEffect(() => {
        requestData()
    }, []);

    const handlePageChange = (page, size) => {
        requestData(page - 1)
    }

    const handleHeaderButtonClick = (event, key) => {
        navigation("/system/auth/edit")
    }


    const handlePasswordInput = (e) => {
        password = e.target.value
    }

    const handleItemDelete = (event, item) => {
        password = null
        Modal.confirm({
            title: '输入当前用户密码以继续',
            icon: <ExclamationCircleOutlined/>,
            content: <>
                <Input.Password onChange={handlePasswordInput}/>
                <Tag color="red">删除前请确认不要影响正在运行的服务</Tag>
            </>,
            okText: '确认',
            cancelText: '取消',
            onOk() {
                SystemApi.removeAuth(item.id, password)
                    .onSuccess(() => {
                        requestData()
                        message.success("已删除")
                    })
            }
        });
    }

    const tableColumns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            width: 60,
        },
        {
            title: 'NAME',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (<TableLongText text={text}/>)
        },
        {
            title: 'APP KEY',
            dataIndex: 'appKey',
            key: 'appKey',
            render: (text) => (<TableLongText text={text}/>)
        },
        {
            title: '上次活动',
            dataIndex: 'lastRequestTime',
            key: 'lastRequestTime',
            render: (text) => (<Tag color={moment().unix() * 1000 - Number(text) > 30000 ? 'red' : 'green'}>{ValueUtils.getMomentOrNull(text).fromNow()}</Tag>)
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 88,
            render: (text, record) => (
                <Space size="small">
                    <Popconfirm title="确定要删除吗" icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                onConfirm={event => handleItemDelete(event, record)} okText="确定" cancelText="暂不">
                        <Button type='danger' size='small' icon={<DeleteOutlined/>}/>
                    </Popconfirm>
                </Space>
            )
        },
    ]

    return (
        <Spin spinning={loading}>
            <DefaultPageHeader
                title={"集群授权管理"}
                buttons={[{name: "添加新授权", key: "new"}]}
                onButtonClick={handleHeaderButtonClick}
            />

            <DefaultTableCard
                currentPage={0}
                columns={tableColumns}
                data={data ?? []}
                total={Number(0)}
                pagesize={Number(0)}
                loading={false}
                onPageChange={handlePageChange}
            />
        </Spin>
    )
}

export default SystemAuthListPage